angular.module('satv.playlist.pitch')
.factory('PitchNoteModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/playlists/modals/pitch-note-form',
                params,
                data
            );
        }
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchNoteModal.js